export default __webpack_public_path__ + "static/media/330_dummy2016-illustrator01-de.68772f22.png";